import ContactUs from '@/pages/ContactUs';
import Faq from '@/pages/Faq';
import ForgotPassword from '@/pages/ForgotPassword';
import Home from '@/pages/Home';
import LiveArchive from '@/pages/LiveArchive';
import LiveConsole from '@/pages/LiveConsole';
import LiveExplore from '@/pages/LiveExplore';
import LiveMenu from '@/pages/LiveMenu';
import LiveSchedule from '@/pages/LiveSchedule';
import LiveScheduleRegistration from '@/pages/LiveScheduleRegistration';
import LiveStreaming from '@/pages/LiveStreaming';
import LiveUpComing from '@/pages/LiveUpComing';
import LiveExpired from '@/pages/LiveExpired';
import UserCreated from '@/pages/UserCreated';
import MyPage from '@/pages/MyPage';
import MyPageTop from '@/pages/MyPageTop';
import Movie from '@/pages/Movie';
import CastMyPageTop from '@/pages/CastMyPageTop';
import CastMyPage from '@/pages/CastMyPage';
import MyPageLikedPerformer from '@/pages/MyPageLikedPerformer';
import ProfilePasswordResetCompleted from '@/pages/ProfilePasswordResetCompleted';
import Payment from '@/pages/Payment';
import Performer from '@/pages/Performer';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Profile from '@/pages/Profile';
import ProfilePasswordReset from '@/pages/ProfilePasswordReset';
import DoronPurchase from '@/pages/DoronPurchase';
// import RankingPatron from '@/pages/RankingPatron';
// import RankingPerformer from '@/pages/RankingPerformer';
import SignIn from '@/pages/SignIn';
import SignUp from '@/pages/SignUp';
import CastSignUp from '@/pages/CastSignUp';
import SpecificTradeLaw from '@/pages/SpecificTradeLaw';
import UserComment from '@/pages/UserComment';
import UserPolicy from '@/pages/UserPolicy';

export default [
  {
    path: '/',
    name: '/',
    component: Home,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/home',
    name: '/home',
    component: Home,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/contact-us',
    name: '/contact-us',
    component: ContactUs,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/faq',
    name: '/faq',
    component: Faq,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/forgot-password',
    name: '/forgot-password',
    component: ForgotPassword,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/live/archive',
    name: '/live/archive',
    component: LiveArchive
  },
  {
    path: '/live/explore',
    name: '/live/explore',
    component: LiveExplore
  },
  {
    path: '/user/created',
    name: '/user/created',
    component: UserCreated,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/user-policy',
    name: '/user-policy',
    component: UserPolicy,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/live/streaming/:liveId',
    name: '/live/streaming',
    component: LiveStreaming
  },
  {
    path: '/live/console/:liveId?',
    name: '/live/console',
    component: LiveConsole
  },
  {
    path: '/live/menu',
    name: '/live/menu',
    component: LiveMenu
  },
  {
    path: '/live/schedule',
    name: '/live/schedule',
    component: LiveSchedule
  },
  {
    path: '/live/schedule/registration',
    name: 'live/schedule/registration',
    component: LiveScheduleRegistration
  },
  {
    path: '/live/upcoming',
    name: '/live/upcoming',
    component: LiveUpComing
  },
  {
    path: '/live/expired/:castId',
    name: '/live/expired',
    component: LiveExpired
  },
  {
    path: '/mypage/liked-performer',
    name: '/mypage/liked-performer',
    component: MyPageLikedPerformer
  },
  {
    path: '/mypage/:menu',
    name: '/mypage',
    component: MyPage,
    props: true
  },
  {
    path: '/mypagetop',
    name: '/mypagetop',
    component: MyPageTop
  },
    {
    path: '/movie',
    name: '/movie',
    component: Movie
  },
  {
    path: '/cast/mypage/:menu',
    name: '/cast/mypage',
    component: CastMyPage,
    props: true
  },
  {
    path: '/cast/mypagetop',
    name: '/cast/mypagetop',
    component: CastMyPageTop
  },
  {
    path: '/profile/passwordreset/completed',
    name: '/profile/passwordreset/completed',
    component: ProfilePasswordResetCompleted
  },
  {
    path: '/payment',
    name: '/payment',
    component: Payment
  },
  {
    path: '/castinfo/:userId',
    name: '/castinfo/userId',
    component: Performer,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/privacy-policy',
    name: '/privacy-policy',
    component: PrivacyPolicy,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/doron/purchase',
    name: '/doron/purchase',
    component: DoronPurchase
  },
  {
    path: '/profile',
    name: '/profile',
    component: Profile
  },
  {
    path: '/profile/passwordreset',
    name: '/profile/passwordreset',
    component: ProfilePasswordReset
  },
  // {
  //   path: '/ranking/patron',
  //   name: 'ranking/patron',
  //   component: RankingPatron
  // },
  // {
  //   path: '/ranking/performer',
  //   name: 'ranking/performer',
  //   component: RankingPerformer
  // },
  {
    path: '/signin',
    name: '/signin',
    component: SignIn,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/email-confirmed',
    name: '/email-confirmed',
    component: SignIn,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/signup',
    name: '/signup',
    component: SignUp,
    props: {
      isAuthCompleted: false
    },
    meta: { skipAuthCheck: true }
  },
  {
    path: '/cast/signup',
    name: '/cast/signup',
    component: CastSignUp,
    props: {
      isAuthCompleted: false
    },
    meta: { skipAuthCheck: true }
  },
  {
    path: '/specific-trade-law',
    name: 'specific-trade-law',
    component: SpecificTradeLaw,
    meta: { skipAuthCheck: true }
  },
  {
    path: '/usercomment',
    name: '/usercomment',
    component: UserComment
  },
  {
    path: '*',
    redirect: '/'
  }
];
